<script setup>
import { onMounted, ref, watch, onBeforeUnmount, nextTick } from 'vue';

const props = defineProps({
  labels: Array,
  values: Array,
  colors: Array,
  percents: Array,
  title: String,
});

const chartRef = ref(null);
let chartInstance = null;

const destroyChart = () => {
  if (chartInstance) {
    chartInstance.destroy();
    chartInstance = null;
  }
};

const renderChart = async () => {
  await nextTick();
  destroyChart();
  if (!chartRef.value) return;
  const ctx = chartRef.value.getContext && chartRef.value.getContext('2d');
  if (!ctx) return;
  const Chart = (await import('chart.js/auto')).default;
  chartInstance = new Chart(ctx, {
    type: 'bar',
    data: {
      labels: props.labels,
      datasets: [
        {
          data: props.values,
          backgroundColor: props.colors,
          borderRadius: 8,
          barPercentage: 0.7,
        },
      ],
    },
    options: {
      indexAxis: 'y',
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: (context) => `${context.label}: ${context.parsed.x} (${props.percents[context.dataIndex]}%)`,
          },
        },
      },
      scales: {
        x: {
          beginAtZero: true,
          ticks: { color: '#64748b', font: { size: 11 } },
          grid: { color: 'rgba(51,65,85,0.1)' },
        },
        y: {
          ticks: { color: '#64748b', font: { size: 11 } },
          grid: { display: false },
        },
      },
      responsive: true,
      maintainAspectRatio: false,
    },
  });
};

onMounted(renderChart);
watch(() => [props.labels, props.values, props.colors, props.percents], renderChart, { deep: true });
onBeforeUnmount(destroyChart);
</script>

<template>
  <div>
    <h3 class="font-semibold text-base mb-2">{{ title }}</h3>
    <div style="height: 180px; width: 100%">
      <canvas ref="chartRef"></canvas>
    </div>
  </div>
</template> 